import {Component} from "@angular/core";
import {Router, ActivatedRoute} from "@angular/router";
import {TourApplication} from "../../service/tour-application/tour-application";
import {TourApplicationService} from "../../service/tour-application/tour-application.service";

@Component({
  selector: 'app-tour-detail',
  templateUrl: 'tour-detail.component.html',
  styleUrls: ['tour-detail.component.scss'],
  providers: [TourApplicationService]
})
export class TourDetailComponent {
  application: TourApplication;
  location: string;
  locationTxt: string;

  timeValues = {
    TEN: { value: 10, text:'10:00~11:00'},
    TEN_HALF: { value: 10.5, text:'10:30~11:30'},
    ELEVEN: { value: 11, text:'11:00~12:00'},
    ELEVEN_HALF: { value: 11.5, text:'11:30~12:30'},
    FOURTEEN: { value: 14, text:'14:00~13:00'},
    FOURTEEN_HALF: { value: 14.5, text:'14:30~15:30'},
    FIFTEEN: { value: 15, text:'15:00~16:00'},
    FIFTEEN_HALF: { value: 15.5, text:'15:30~16:30'},
    SIXTEEN: { value: 16, text:'16:00~17:00'},
    SIXTEEN_HALF: { value: 16.5, text:'16:30~17:30'},
  };

  constructor(private applicationService: TourApplicationService, private route: ActivatedRoute, private router: Router)
  {
    this.route.params.subscribe(
      params => {
        let cache = JSON.parse(sessionStorage.getItem('__hey_tourDetail'));
        if(cache) {
          this.application = cache;
          this.location =  cache.location.key;
          this.locationTxt = cache.location.key === 'seongsu' ? '성수 시작점' : '서울숲점';

          if(params.id != cache.id) this.router.navigate(['/tour/lookup'])
        } else {
          this.router.navigate(['/tour/lookup'])
        }
      }
    )
  }

  cancleTour() {
    const { id, name, phone, location } = this.application
    this.applicationService.cancle(id, name, phone).subscribe(o => {
      window.alert('투어신청이 취소되었습니다.')
      sessionStorage.removeItem('__hey_tourDetail')
      sessionStorage.removeItem('__hey_tourList')

      this.router.navigate([location.key, 'tour'])
    });
  }

  private guideLink ={
    'seoulsoop': 'https://heyground.com/share/%5B%EC%84%9C%EC%9A%B8%EC%88%B2%EC%A0%90%5D+%EC%BD%94%EC%9B%8C%ED%82%B9+%EC%8A%A4%ED%8E%98%EC%9D%B4%EC%8A%A4+%ED%88%AC%EC%96%B4+%EA%B0%80%EC%9D%B4%EB%93%9C.pdf',
    'seongsu': 'https://heyground.com/share/%5B%EC%84%B1%EC%88%98+%EC%8B%9C%EC%9E%91%EC%A0%90%5D+%EC%BD%94%EC%9B%8C%ED%82%B9+%EC%8A%A4%ED%8E%98%EC%9D%B4%EC%8A%A4+%ED%88%AC%EC%96%B4+%EA%B0%80%EC%9D%B4%EB%93%9C.pdf'
  }
  getTourLink(location) {
    return this.guideLink[location]
  }
}



// WEBPACK FOOTER //
// ./src/app/space/tour-detail/tour-detail.component.ts